import { Typography } from "@platform/design-system";

function NoDataMessage(): React.JSX.Element {
  return (
    <Typography variant="body-large" sx={{ ml: 3 }}>
      <em>Your Carrier does not send this data.</em>
    </Typography>
  );
}

export default NoDataMessage;
